export const DASHBOARD_PARAM = {
  page: 'page',
  rowsPerPage: 'rowsPerPage',
  q: 'q',
  sort: 'sort',
  grades: 'grades',
  schools: 'schools',
  roleIds: 'roleIds',
  programs: 'programs',
  institutionRoles: 'institutionRoles',
  verified: 'verified',
  cohortIds: 'cohortIds',
  coachIds: 'coachIds',
  tab: 'tab',
  institutionId: 'institutionId',
  rosterId: 'rosterId',
  kind: 'kind',
} as const;

export type ParamUpdates = Record<string, string | string[] | number | null>;

export const applyParamUpdates = (
  prev: URLSearchParams,
  updates: ParamUpdates,
): URLSearchParams => {
  const next = new URLSearchParams(prev);

  for (const [key, value] of Object.entries(updates)) {
    const isEmpty = value === null || value === '' || (Array.isArray(value) && value.length === 0);

    if (isEmpty) {
      next.delete(key);
    } else if (Array.isArray(value)) {
      next.set(key, value.join(','));
    } else {
      next.set(key, String(value));
    }
  }

  return next;
};

export const parseIntParam = (value: string | null, fallback: number): number => {
  if (value === null) return fallback;

  const parsed = parseInt(value, 10);

  return Number.isNaN(parsed) ? fallback : parsed;
};

export const parseNullableIntParam = (value: string | null): number | null => {
  if (value === null || value === '') return null;

  const parsed = parseInt(value, 10);

  return Number.isNaN(parsed) ? null : parsed;
};

export const parseListParam = (value: string | null): string[] =>
  value ? value.split(',').filter(Boolean) : [];

export const parseNumberListParam = (value: string | null): number[] =>
  parseListParam(value)
    .map((entry) => parseInt(entry, 10))
    .filter((entry) => !Number.isNaN(entry));
